<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import { getConfigurationContext } from "$lib/elev8Api/configurationContext.svelte";
  import {
    cleanupDataPipeline,
    initDataPipeline,
    setUploadMaxBytes,
  } from "./dataPipelineManager";
  import { currentEnvironment } from "$lib/utils/previewMode";

  interface Props {
    displayId: string;
  }

  let { displayId }: Props = $props();
  const config = getConfigurationContext();

  onMount(() => {
    initDataPipeline(displayId, currentEnvironment());
  });

  onDestroy(() => {
    cleanupDataPipeline();
  });

  $effect(() => {
    setUploadMaxBytes(config.settings.data_pipeline_upload_max_bytes);
  });
</script>
